import { FC } from 'react';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { usePwcNavigate } from '@app/core/hooks/routing-hooks';
import PwcNavigate from '@app/shared/routing/PwcNavigate';
import { RouteConstants } from '@app/modules/projects/RouteConstants';
import { CalcMethod } from '@app/shared/models/contracts/enums/shared-enums';
import { enumKeyByValue } from '@app/shared/helpers';

export const SponsorIRRAndHurdlePage: FC = (): JSX.Element => {
  const projectCalcMethod = useAppSelector(
    (state) => state.project.projectDraft.details.calcMethod
  );
  const isOpm = projectCalcMethod === enumKeyByValue(CalcMethod, CalcMethod.OPM);
  const storedSponsorIrrAndHurdleTab = useAppSelector(
    (state) => state.uiValues.userSelections.sponsorIrrAndHurdle.selectedTab
  );

  const { generatePath } = usePwcNavigate();

  const selectedTab = isOpm
    ? RouteConstants.IRRHurdleCalculations
    : storedSponsorIrrAndHurdleTab ?? RouteConstants.SponsorIRR;

  return <PwcNavigate route={generatePath(selectedTab)} preserveSearch />;
};
